// extracted by mini-css-extract-plugin
export default {"container":"m_-z","creativeContainer":"n_-z","copy":"o_-z","cta":"p_-z","disabled":"q_-z","flipped":"r_-z","productCard":"s_-z"};